window.whatsApp = function() {
    if (window.scrollY < 100) {
        $('.whatsapp').css('right', '15px')
    } else {
        $('.whatsapp').css('right', '70px')
    }
};
